angular.module('taric.model.menu', ['ngResource', 'common.config']).service('MenuModel', function(){
	
	var observerCallbacks = [];
	var printable = false;
	var exportable = false;
	var helpIndex = '';

    var helpMaps = {
    		"taric.nomenclature.sbn" : 1,
    		"taric.nomenclature.sbt" : 2,
    		"taric.adco.view" : 2,
    		"taric.nomenclature.ct" : 3,
    		"taric.measure.ccrm" : 4,
    		"taric.measure.mcc" : 5,
    		"taric.duty.calculate" : 6,
    		"taric.duty.exchangerates" : 7,
    		"taric.duty.meursing" : 8,
    		"taric.quota.search" : 9,
    		"taric.quota.view" : 9,
    		"taric.report.pt": 10,
    		"taric.moreinfo.links": 11,
    		"taric.moreinfo.codelists.search" : 65,
    		"taric.moreinfo.codelists.view" : 65,
			"taric.report.relief.search": 44,
        	"taric.report.relief.view": 44,
        	"taric.report.mlr": 66,
			"taric.report.measure": 67,
			"taric.report.measureAmendments": 68
    };

    var printableStates = ['taric.quota.search',
		                   'taric.quota.view',
                           'taric.nomenclature.ct',
                           'taric.measure.ccrm',
                           'taric.measure.mcc',
                           'taric.duty.exchangerates',
                           'taric.duty.meursing',
                           'taric.report.pt',
                           'taric.moreinfo.links',
                           'taric.moreinfo.codelists',
                           'taric.nomenclature.sbt',
                           'taric.moreinfo.codelists.search',
                           'taric.moreinfo.codelists.view',
		                   'taric.report.relief.search',
		                   'taric.report.relief.view',
		                   'taric.report.mlr',
		                   'taric.report.measure',
		                   'taric.report.measureAmendments'];

    var exportableStates = ['taric.duty.exchangerates',
							'taric.moreinfo.codelists.search',
							'taric.moreinfo.codelists.view',
							'taric.report.measure',
							'taric.report.measureAmendments',
							'taric.nomenclature.ct',
							'taric.report.mlr'];
    
	var enablePrintable = function() {
		printable = true;
	};
	
	var disablePrintable = function() {
		printable = false;
	};
	
	var enableExportable = function() {
		exportable = true;
	};
	
	var disableExportable = function() {
		exportable = false;
	};
	
	var setHelpIndex = function(index) {

        if (printableStates.indexOf(index) > -1) {
        	
        	enablePrintable();
        } else {
        	
        	disablePrintable();
        }
        
        if (exportableStates.indexOf(index) > -1) {
        	
        	enableExportable();
        } else {
        	
        	disableExportable();
        }
        
		helpIndex = helpMaps[index];
	};

	var registerObserverCallback = function(callback){
	    observerCallbacks.push(callback);
	};
	
	var notifyObservers = function(){

		angular.forEach(observerCallbacks, function(callback){
	    	callback();
	    });
	};

	var data = function(){
		return {
			printable: printable,
			exportable: exportable,
			helpIndex: helpIndex
		};
	};
	
	return {
		enablePrintable: enablePrintable,
		disablePrintable: disablePrintable,
		enableExportable: enableExportable,
		disableExportable: disableExportable,
		setHelpIndex: setHelpIndex,
		registerObserverCallback: registerObserverCallback,
		notifyObservers: notifyObservers,
		data: data
	};
});



// WEBPACK FOOTER //
// ./app/common/model/taric/menu-model.js